<template>
  <ExpenseForm :expense="expense" :onSubmit="submit"></ExpenseForm>
</template>

<script>
import ExpenseForm from './Expense-Form.vue';
import { busEvent } from '../../main';

export default {
  name: 'CreateExpense',
  components: {
    ExpenseForm,
  },
  data: () => ({
    expense: {
      documentNr: '',
      description: '',
      amount: 0,
      date: new Date().toISOString(),
      containsVAT: true,
      isCashDeposit: false,
      paymentType: 'cash'
    },
  }),
  methods: {
    submit() {
      this.$store.dispatch('expenses/createExpense', this.expense)
        .then(() => {
          busEvent.$emit('succesPopupCreated', 'Cheltuiala a fost creata');
          this.$router.back()
        });
    },
  },
};
</script>
